import { render } from "./IconCheckboxUnchecked.vue?vue&type=template&id=d4f06674"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__